module.exports = __webpack_public_path__ + "img/sv85.2ef7a8a3.svg";